import { Injectable } from '@angular/core';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { SaleRegistryPrintingQuery, SaleRegistryPrintingQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SaleRegistryPrintingQuery)
@Wrapper(SaleRegistryPrintingQueryHandlerBase)
export class SaleRegistryPrintingQueryHandler {
    public constructor(
        http: Http
    ) { }
}
